// @flow
import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Container, Grid, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LoadSVG from '../components/LoadSVG';
import { Link, Redirect } from 'react-router-dom';
import type { AcfFields } from '../types/personas';
import { loadMarketingPage } from '../actions/readMarketingPage';
import { fetchPersonas } from '../actions/personas';
import PageContent from '../components/PageContent';
import { getPersonasSortedAlphabetically } from '../reducers/personas';
import PageTitle from '../components/PageTitle';
import PageLoader from '../components/PageLoader';
import { fetchProducts } from '../actions';
import { findBySlug } from '../helpers';
import type { Product as ProductType, Persona as PersonaType } from '../types';
import OtherProducts from '../components/OtherProducts';

type Props = {
  acf: AcfFields,
  images: [
    {
      url: string,
      alt: string,
      title: string
    }
  ],
  fetchPersonas: () => Promise<void>,
  loadMarketingPage: (slug: string) => Promise<void>,
  link: string,
  fetchProducts: () => Promise<void>,
  products: Array<Object>,
  match: {
    params: {
      community_slug: string,
      persona_slug: string
    }
  },
  personas: Array<PersonaType>,
  isFetching: () => Promise<void>,
  marketingPage: () => Promise<void>
};

class Persona extends React.Component<Props> {
  componentDidMount() {
    this.props.fetchPersonas();
    this.props.loadMarketingPage('helix-personas-2018-homepage');
    this.props.fetchProducts();
    window.scrollTo(0, 0);
  }

  render() {
    const currentSlug = this.props.match.params.community_slug.substring(0, 3);
    const currentPersonaSlug = this.props.match.params.persona_slug.substring(
      0,
      3
    );
    const { products } = this.props;
    const slug = 'helix-personas';

    let currentProduct: ?ProductType;
    if (products) {
      currentProduct = (findBySlug(products, slug): ProductType);
    }
    let community;
    //check this.props.personas exists and has lengh > 0
    if (this.props.personas && this.props.personas.length > 0) {
      community = this.props.personas.find(function(item) {
        return item.slug === currentSlug;
      });
    }
    if (
      this.props.isFetching ||
      !this.props.marketingPage ||
      !currentProduct ||
      !community
    ) {
      return <PageLoader />;
    }

    // let persona: ?PersonaType;
    //check community.personas exists and has lengh > 0
    const persona: PersonaType = community.personas.find(function(item) {
      return item.slug === currentPersonaSlug;
    });

    if (!persona) {
      return <Redirect to={`/${this.props.match.params.community_slug}`} />;
    }
    return (
      <div>
        <PageTitle
          title={'Helix Personas'}
          strapline={persona.postTitle ? persona.postTitle : undefined}
        />
        <Container>
          <div className="content page-row container">
            <Grid columns={2} stackable>
              <Grid.Row>
                <Grid.Column className="persona-tile__wrapper">
                  <div className="persona-tile">
                    <div className="persona-tile__number">
                      {persona.postName}
                    </div>
                    <div className="persona-tile__name">
                      {persona.acf.title}
                    </div>
                    <div className="persona-tile__content">
                      <div className="persona-tile__stats-container">
                        <span className="persona-tile-stat">
                          <span className="persona-tile-stat__icon">
                            {persona.acf.excerptIcon1 &&
                              persona.acf.excerptIcon1.image &&
                              persona.acf.excerptIcon1.image.url && (
                                <LoadSVG
                                  src={persona.acf.excerptIcon1.image.url}
                                  title={persona.acf.excerptIcon1.image.title}
                                  alt={persona.acf.excerptIcon1.image.alt}
                                  colour={persona.acf.color}
                                />
                              )}
                          </span>
                          {persona.acf.excerptNumberOnLeft1 && (
                            <span className="persona-tile-stat__figure">
                              {persona.acf.excerptValue1}{' '}
                              {persona.acf.excerptLabel1}
                            </span>
                          )}
                          {!persona.acf.excerptNumberOnLeft1 && (
                            <span className="persona-tile-stat__figure">
                              {persona.acf.excerptLabel1}{' '}
                              {persona.acf.excerptValue1}
                            </span>
                          )}
                        </span>
                        <span className="persona-tile-stat">
                          <span className="persona-tile-stat__icon">
                            {persona.acf.excerptIcon2 &&
                              persona.acf.excerptIcon2.image &&
                              persona.acf.excerptIcon2.image.url && (
                                <LoadSVG
                                  src={persona.acf.excerptIcon2.image.url}
                                  title={persona.acf.excerptIcon2.image.title}
                                  alt={persona.acf.excerptIcon2.image.alt}
                                  colour={persona.acf.color}
                                />
                              )}
                          </span>
                          {persona.acf.excerptNumberOnLeft2 && (
                            <span className="persona-tile-stat__figure">
                              {persona.acf.excerptValue2}{' '}
                              {persona.acf.excerptLabel2}
                            </span>
                          )}
                          {!persona.acf.excerptNumberOnLeft2 && (
                            <span className="persona-tile-stat__figure">
                              {persona.acf.excerptLabel2}{' '}
                              {persona.acf.excerptValue2}
                            </span>
                          )}
                        </span>
                      </div>

                      <div className="persona-tile__text">
                        {ReactHtmlParser(persona.acf.summaryExcerpt)}
                      </div>
                      <div className="persona-tile__button-container">
                        <Button
                          as={Link}
                          target={'_self'}
                          to={`//live.roymorgan.com/products/helix-personas`}
                          style={{
                            backgroundColor: persona.acf.color,
                            marginBottom: '10px',
                            display: 'table'
                          }}
                        >
                          Read more about Helix Personas
                        </Button>
                        {persona && persona.acf && persona.acf.community && (
                          <Button
                            as={Link}
                            to={`/${
                              persona.acf.community.slug
                            }-${persona.acf.community.title
                              .toLowerCase()
                              .replace(/ /g, '-')}`}
                            style={{
                              backgroundColor: persona.acf.color,
                              marginBottom: '10px',
                              display: 'table'
                            }}
                          >
                            See more Personas in{' '}
                            {persona.acf.community.slug +
                              ' ' +
                              persona.acf.community.title}
                          </Button>
                        )}
                        <Button
                          as={Link}
                          target={'_blank'}
                          to={`//helix.roymorgan.com/personas/${
                            persona.acf.personacommunityNumber
                          }/know-me`}
                          style={{
                            backgroundColor: persona.acf.color,
                            marginBottom: '10px',
                            display: 'table'
                          }}
                        >
                          Log in to explore {persona.postTitle}
                        </Button>
                      </div>
                    </div>
                  </div>
                </Grid.Column>

                <Grid.Column>
                  <div className="persona-images-grid">
                    {persona.knowMeImageGallery.slice(0, 6).map((item, key) => (
                      <div key={key}>
                        <img src={item.url} alt={item.alt} title={item.title} />
                      </div>
                    ))}
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Container>
        <PageContent
          pageContent={
            this.props.marketingPage.acf.pageContent
              ? this.props.marketingPage.acf.pageContent
              : undefined
          }
        />
        <OtherProducts currentProduct={currentProduct} />
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    personas: getPersonasSortedAlphabetically(state),
    marketingPage: state.marketingPages.pages['helix-personas-2018-homepage']
      ? state.marketingPages.pages['helix-personas-2018-homepage']
      : undefined,
    isFetching: state.marketingPages.isFetching,
    products: state.products.items
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchPersonas,
      loadMarketingPage,
      fetchProducts
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Persona);
